import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SyncService } from 'app/services/sync.service';
import { MatBadgeModule } from '@angular/material/badge';
import { AsyncPipe } from '@angular/common';
import {
  interval,
  map,
  of,
  shareReplay,
  skip,
  Subscription,
  switchMap,
  take,
  takeWhile,
} from 'rxjs';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-sync-toolbar',
  imports: [AsyncPipe, MatButtonModule, MatIconModule, MatBadgeModule],
  templateUrl: './sync-toolbar.component.html',
  styleUrl: './sync-toolbar.component.scss',
})
export class SyncToolbarComponent {
  protected syncService = inject(SyncService);
  isLoading = this.syncService.isLoading;
  totalNotSyncItemsCount$ = this.syncService.getNotSyncedObjectsCount();
  displayTime = this.syncService.displayTime;
  isOnline = this.syncService.isOnline;
  startSync() {
    this.syncService.startSync();
  }
}
